import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PrivacyPolicy from './PrivacyPolicy';

// Lightweight routing (no react-router needed):
// /privacy-policy -> Privacy Policy page, everything else -> main site
const path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
const Page = path === '/privacy-policy' ? PrivacyPolicy : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);
